import React, { useEffect } from 'react';
import { connect } from "react-redux";
import UserEl from './UserEl';
import './DlUnitLi.scss';
import { getUserLi } from "./../../actions";
import AddNew from './AddNew';

const mapStateToProps = (state) => ({
  itemN: state.userLi.userN
});

const mapDispatchToProps = (dispatch) => ({
  getItemLi: (payload) => dispatch(getUserLi(payload))
});

const UserLi = ({ itemN, getItemLi }) => {

  useEffect(function() {
    getItemLi();
  }, []);

  const itemLi = itemN.map( (item, ind) => (
    <UserEl key={ind} item={item} />
  ) );

  return (
    <div>
      <AddNew adr={'/admin-dashboard/user-edit'} />
      { itemLi }
    </div>
  );

}

export default connect(mapStateToProps, mapDispatchToProps)(UserLi);
